import { render } from "./SearchChannel.vue?vue&type=template&id=1313cfb0"
import script from "./SearchChannel.vue?vue&type=script&lang=js"
export * from "./SearchChannel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__